import InventoryApiCall from "InventoryApiCall";
import config from "config";

// export const getInventoryAccessDetails = () => {
//     const apiPath = "/vendor/api/vendor.php";

//     return async (dispatch) => {
//         const requestData = {
//             vendorEmail: config.instructorInfo.data.EmailId,
//         };

//         try {
//             const jsonResponse = await InventoryApiCall.makeApiCall(
//                 "inventory_getVendorsInstitutes",
//                 requestData,
//                 apiPath
//             );

//             if (jsonResponse.expired) {
//                 // Retry the request after 1 second
//                 setTimeout(() => {
//                     dispatch(getInventoryAccessDetails());
//                 }, 1000);
//             } else if (jsonResponse.success) {
//                 const apiResult = jsonResponse.APIResult.data;
//                 dispatch(getAssignedIIDArray(apiResult.iidArray));
//                 dispatch(getAssignedInstituteObject(apiResult.iidDetails));
//             } else {
//                 console.error("API returned an error:", jsonResponse.error);
//             }
//         } catch (error) {
//             console.error("Error making API call:", error);
//         }
//     };
// };

// Action creators for setting data


export const getAssignedIIDArray = (assignedIIDArray) => ({
    type: "ASSIGNED_IID_ARRAY",
    payload: assignedIIDArray,
});

export const getAssignedInstituteObject = (iidDetails) => ({
    type: "ASSIGNED_IID_DETAILS",
    payload: iidDetails,
});